import { useCallback } from "react";
import { useUserTypesMap } from "./useUserTypesMap";

export const useFormData = () => {
  const { userTypesMap } = useUserTypesMap();

  const getFormData = useCallback(
    (req: any) => {
      const data = { ...req };

      delete data.file;
      delete data.notificationRecipientTypes;

      const selectedTypes: number[] = [];

      const enries: any = Object.entries(userTypesMap);

      if (req.notificationRecipientTypes) {
        for (const [key, value] of enries) {
          req.notificationRecipientTypes[value] && selectedTypes.push(+key);
        }
      }

      if (selectedTypes.length > 0) {
        data.notificationRecipientTypes = selectedTypes;
      }

      data.saveOriginalAttachmentAsDocument = !!req.saveOriginalAttachmentAsDocument;

      if (req.document) {
        data.document.date = req.document.date.format();

        data.document.isHolding = !!req.document.isHolding;

        if (!data.document.description) {
          delete data.document.description;
        }
      }

      return data;
    },
    [userTypesMap]
  );

  return { getFormData };
};
